// İSG uzmanı portalı — global app-store linkleri okuma kancası (api-contract §26.1
// `GET /app-settings`). Global singleton (firma-bazlı DEĞİL) — anahtara companyId
// KATILMAZ. Herhangi bir kimlik-doğrulanmış principal okur (grant gerekmez); anasayfa
// app-info kartı + "Mobil Uygulama" sayfası bunu paylaşır. Ayar boşsa alanlar `null`
// (uygulama mağazada değil) → çağıran "yakında" gösterir.
//
// Hata (5xx/ağ) durumunda alanlar `null`'a düşer (bilinçli): app-link'ler kritik olmayan
// bilgidir; kart ham hata yerine "yakında" gösterir (nazik degrade). Süre uzun tutulur
// (linkler nadir değişir). web-supplier `useAppSettings` ile AYNI desendir.

import { appSettingsApi } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';

/** Global (firma-bağımsız) app-settings sorgu anahtarı. */
const appSettingsQueryKey = ['app-settings'] as const;

export interface AppDownloadState {
  iosAppUrl: string | null;
  androidAppUrl: string | null;
  /** İlk yükleme sürüyor (spinner). */
  isLoading: boolean;
}

/**
 * Global app-store linklerini getirir (§26.1). `isLoading` sürerken çağıran spinner
 * gösterir; bittiğinde `iosAppUrl`/`androidAppUrl` (biri/ikisi `null` olabilir) döner.
 * Hata durumunda ikisi de `null` (nazik degrade → "yakında").
 */
export function useAppSettings(): AppDownloadState {
  const query = useQuery({
    queryKey: appSettingsQueryKey,
    queryFn: () => appSettingsApi.getAppSettings(),
    staleTime: 5 * 60_000,
    retry: false,
  });

  return {
    iosAppUrl: query.data?.iosAppUrl ?? null,
    androidAppUrl: query.data?.androidAppUrl ?? null,
    isLoading: query.isPending,
  };
}
